var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"gisDom",attrs:{"id":"container","oncontextmenu":_vm.doNothing}}),_c('div',{attrs:{"id":"bimContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }